import React from "react";
import styled from "styled-components";

export function MaybeTooltipWrapper(props:{
    children:React.ReactNode,
    tooltip?:React.ReactNode,
}): JSX.Element
{
    if(props.tooltip)
    {
        return (
            <TooltipTheOneWrapper tooltipContent={props.tooltip} divWrapper>
                {props.children}
            </TooltipTheOneWrapper>
        );
    }
    else {
        return <>{props.children}</>;
    }
}

type TooltipTheOneWrapperProps = {
    children: React.ReactNode,
    tooltipContent?: React.ReactNode,
    divWrapper?: boolean,
    wrapperStyle?: React.CSSProperties,
    containerStyle?: React.CSSProperties,
    horizontalAlignment?: 'left' | 'right',
    verticalAlignment?: 'top' | 'bottom',
    display?:string,
    flex?:string,
    style?: React.CSSProperties,
};
export function TooltipTheOneWrapper (props: TooltipTheOneWrapperProps): JSX.Element
{
    const [showTooltip, setShowTooltip] = React.useState(false);

    const wrappedContent =
        <>
            {props.children}
            {showTooltip && props.tooltipContent && 
                <TooltipTheOneContainer style={props.containerStyle} horizontalAlignment={props.horizontalAlignment || 'right'} verticalAlignment={props.verticalAlignment}>
                    {props.tooltipContent}
                </TooltipTheOneContainer>
            }
        </>;

    const wrapperProps = {
        onMouseOver: () => setShowTooltip(true),
        onMouseOut: () => setShowTooltip(false),
    };

    const wrapperStyle = {
        position: 'relative' as const,
        flex: props.flex || undefined,
        display: props.display || undefined,
        ...props.wrapperStyle
    };

    return (

        <>
            {props.divWrapper
                ?
                <div {...wrapperProps} style={wrapperStyle}>
                    {wrappedContent}
                </div>
                :
                <span {...wrapperProps} style={wrapperStyle}>
                    {wrappedContent}
                </span>
            }
        </>
    );
}

const Gray_dark = "rgba(61,61,61,1)";

const TooltipTheOneContainer = styled.span<{ horizontalAlignment: 'left' | 'right', verticalAlignment?: 'top' | 'bottom' }>`
    position: absolute;
    z-index: 99999999;
    top:100%;

    ${props => props.horizontalAlignment === 'left' ? 'left:0;' : 'right:0;'}
    ${props => props.verticalAlignment === 'top' ? 'bottom:100%; top:auto;' : ''}
    
    width: max-content;
    max-width: 400px;
    padding: 10px;
    transition: opacity 0.3s;
    
    background-color: ${Gray_dark};
    border-width: 1px;
    border-radius: 4px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
    font-family: "Noto Sans", sans-serif;
    font-size: 14px;
    color:#fff;
    font-weight: 400;
    
`;